"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noUserDragImageMixin = exports.noSelectMixin = void 0;
/*
  Mixins are a pattern from sass/less (e.g. https://sass-lang.com/documentation/at-rules/mixin)
  in css preprocessors to add in multiple style declarations in a single line.

  You can really take this in a lot of directions like bundling commonly used styles together.

  However, one place this was commonly used was to bundle browser compatable prefixed properties together,
  and that is why this file was started and likely how it's being used.

  With tools like auto-prefixer (https://autoprefixer.github.io/), which are built into
  create react app (https://create-react-app.dev/), it is likely that this file will obsolete itself
  OR be used more in the manner of bundling commonly used pairs of style declarations
*/

var noSelectMixin = {
  WebkitUserSelect: "none",
  KhtmlUserSelect: "none",
  MozUserSelect: "none",
  msUserSelect: "none",
  userSelect: "none"
};
exports.noSelectMixin = noSelectMixin;
var noUserDragImageMixin = {
  userDrag: "none",
  userSelect: "none",
  MozUserSelect: "none",
  WebkitUserDrag: "none",
  WebkitUserSelect: "none",
  msUserSelect: "none"
};
exports.noUserDragImageMixin = noUserDragImageMixin;